const styleSettings = {
	surfaceTransitionDuration: 320
};

export default styleSettings;
